<template>

    <div class="py-5" >
        
       <Title/>

        <b-container>
            <b-card>
                <div class="text-right"> 
                    <!--<b-btn variant="info" :to="{ name: 'Profile' }">My Profile</b-btn>-->
                </div>
                
                
                <div class="text-left pb-1">
                    <h6>My Rooms</h6>
                </div>
                
                <b-alert :show="rooms.length == 0" variant="secondary">No rooms created.</b-alert>
                <b-list-group>
                    <b-list-group-item v-for="room in rooms" :key="room._id" class="d-flex">
                        <div class="flex-fill text-left align-self-center">{{ room.name }}</div>
                        <div>
                            <b-btn variant="primary" class="mr-2" :to="{ name: 'Microscope', query: { room: room._id, name: room.name }}">Enter</b-btn>
                            <b-btn variant="info" @click="currentRoom = room; $refs.shareModal.show()" class="mr-2">Share</b-btn>
                            <b-btn variant="danger" @click="deleteRoom(room)">Delete</b-btn>
                        </div>
                    </b-list-group-item>
                </b-list-group>

                <div class="text-left pb-1 pt-4">
                    <h6>Shared Rooms</h6>
                </div>
                
                <b-alert :show="sharedRooms.length == 0" variant="secondary">No rooms shared with you.</b-alert>
                <b-list-group>
                    <b-list-group-item v-for="room in sharedRooms" :key="room._id" class="d-flex">
                        <div class="flex-fill text-left align-self-center">{{ room.name }}</div>
                        <div>
                            <b-btn variant="primary" class="mr-2"
                            :to ="{ name: 'Microscope', query: { room: room._id, name: room.name }}">Enter</b-btn>
                        </div>
                    </b-list-group-item>
                </b-list-group>

                <div class="text-right pt-3">
                    <b-btn variant="primary" to="/add-room">Create a room</b-btn>
                </div>
            </b-card>
        </b-container>

        <b-modal title="Share Room" ref="shareModal" ok-only>
            <b-form-group label="Users to share with" description="Enter emails seperated by commas">
                <b-input-group>
                    <b-form-input v-model="emails" />
                    <b-form-group-append>
                        <b-btn @click="share" :disabled="waitingForResponse" variant="primary" class="h-100" style="border-radius: 0 1.078em 1.078em 0">Share</b-btn> 
                    </b-form-group-append>
                </b-input-group>
            </b-form-group>

            <h6>Shared with:</h6>
            <b-list-group v-if="currentRoom.sharedWith && currentRoom.sharedWith.length > 0">
                <b-list-group-item v-for="(email,index) in currentRoom.sharedWith" :key="email" class="d-flex">
                    <div class="flex-fill align-self-center">{{ email }}</div>
                    <b-btn variant="danger" @click="removeUser(index)">Delete</b-btn>
                </b-list-group-item>
            </b-list-group>

            <b-alert v-else variant="secondary" show class="mt-2">Not shared with anyone.</b-alert>
        </b-modal>
    </div>
</template>

<script>
import Title from '@/components/Title'

export default {
    data() {
        
        return {
            rooms: [],
            sharedRooms: [],
            currentRoom: {},
            emails: '',
            waitingForResponse: false,
            user: []
        }
    },
components: {Title},
    async mounted() {
        this.user = await this.$app.service('users').get('$userId');
        
        this.rooms = (await this.$app.service('rooms').find({ query: { userId: '$userId' }})).data;

        this.sharedRooms = (await this.$app.service('rooms').find({ query: { sharedWith: '$userEmail' }})).data;

        //this.users = (await this.$app.service('users').find({ query: { firstName: '$firstName' }})).data;
        // this.$app.service('users').find({ 
        // 		firstName: this.firstName}),
        // this.$app.authenticate()
        // .then(() => this.$router.push({ name: 'Dashboard' }))
        
        

    },

    methods: {
        async deleteRoom(room) {
            if (window.confirm('Are you sure you want to delete this room?')){
                await this.$app.service('rooms').remove(room._id);
                this.rooms.splice(this.rooms.indexOf(room), 1);
            }
        },

        async share() {
            this.waitingForResponse = true;

            var users = this.currentRoom.sharedWith || [];
            var newUsers = this.emails.split(',');
            var evenNewerUsers = [];

            for (let i = 0; i < newUsers.length; i++) {
                if (newUsers[i].indexOf('@') > 0) {
                    evenNewerUsers.push(newUsers[i]);
                } else {
                    alert(`'${newUsers[i]}' is not an email.`);
                }
            }

            users.push(...evenNewerUsers);
            await this.$app.service('rooms').patch(this.currentRoom._id, { sharedWith: users });
            this.$set(this.currentRoom, 'sharedWith', users);

            this.emails = '';
            this.waitingForResponse = false;
        },

        removeUser(index) {
            if (window.confirm('Are you sure you want to stop sharing with this user?')) {
                this.currentRoom.sharedWith.splice(index, 1);
                this.$app.service('rooms').patch(this.currentRoom._id, { sharedWith: this.currentRoom.sharedWith });
            }
        }
    }
}
</script>

